import React, { Component } from 'react';
import { connect } from 'react-redux';

import {fetchLeaderboardAndRecords, clearLeaderboardRecords} from 'actions/leaderboards.js';
import {getLeaderboard, getLeaderboardRecords, getLeaderboardRecordsEnd} from 'reducers/leaderboards.js';
import {LeaderboardContainerUnconnected} from './LeaderboardContainer.js';

class TeamLeaderboardContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <LeaderboardContainerUnconnected {...this.props} />;
    }
}

const mapStateToProps = (state, ownProps) => {
    var leaderboard = ownProps.leaderboard;
    var column = leaderboard.column || 'points';
    var userProfile = state.user.userProfile;
    return {userProfileId:(userProfile ? userProfile.id : null),
            column:column, 
            records:getLeaderboardRecords(state.leaderboards, leaderboard.id),
            end:getLeaderboardRecordsEnd(state.leaderboards, leaderboard.id)};
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: (id, start, limit) => dispatch(fetchLeaderboardAndRecords(id, start, limit)),
        dispatch: dispatch
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(TeamLeaderboardContainer);



// WEBPACK FOOTER //
// ./src/modules/leaderboards/TeamLeaderboardContainer.js